export default function getCurrentBySlug(allParent, currentSlug) {
  if (allParent?.length) {
    return [...allParent].filter(
      (it) => it.slug == currentSlug || !!it.children?.find((i) => i.slug == currentSlug)
    )[0];
  } else {
    return null;
  }
}
